import React from 'react';
import PropTypes from 'prop-types';

import t from '../../../lib/I18n';
import Checkbox from '../../form/Checkbox';
import HelpIcon from '../../general/HelpIcon';

export default function AgeCheckbox({ isOver16, onToggle }) {
    const CheckBoxLabel = (
        <span>
            {t('preference-centre.age-restriction')}
            <HelpIcon
                heading="preference-centre.age-restriction.title"
                message={t('preference-centre.age-restriction.modal-text')}
                centerMessage
            />
        </span>
    );

    return (
        <div className="margin-bottom--sm">
            <Checkbox
                className="marketing-preferences__age-toggle"
                data-test-id="marketing-prefs-over-16-checkbox"
                onChange={onToggle}
                checked={isOver16}
                label={CheckBoxLabel}
            />
        </div>
    );
}

AgeCheckbox.propTypes = {
    onToggle: PropTypes.func.isRequired,
    isOver16: PropTypes.bool,
};

AgeCheckbox.defaultProps = {
    isOver16: false
};
